import { render, staticRenderFns } from "./AppAnnotationPart1.vue?vue&type=template&id=29932e65&scoped=true"
import script from "./AppAnnotationPart1.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationPart1.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationPart1.vue?vue&type=style&index=0&id=29932e65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29932e65",
  null
  
)

export default component.exports